import {
  PersonalizeToneOption,
  TONE_OPTIONS,
} from "features/Influencer/QuickSendIndividualDrawer/Dialogs/PersonalizeDialog/schema";

export const BRIEF_TONE_OPTIONS = TONE_OPTIONS.filter(
  (t) =>
    t.id !== PersonalizeToneOption.makeShorter &&
    t.id !== PersonalizeToneOption.addDetail,
);

export const EMPHASIS_OPTIONS = [
  "Recent launches",
  "Audience fit",
  "My engagement rate",
  "Content ideas",
  "Past collabs",
  "Seasonal angle",
];

export interface PersonalizationBrief {
  startingTemplateId?: number | null;
  emphasis: string[];
  tone?: PersonalizeToneOption | null;
  notes?: string;
}
